import { render } from "./Project.Detail.vue?vue&type=template&id=58d0b553&scoped=true"
import script from "./Project.Detail.vue?vue&type=script&lang=js"
export * from "./Project.Detail.vue?vue&type=script&lang=js"

import "./Project.Detail.vue?vue&type=style&index=0&id=58d0b553&scoped=true&lang=scss"

import exportComponent from "/Users/devgroup/work/hanbyul/hanbyeol/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d0b553"]])

export default __exports__